export function getCssVar(property, defaultValue = null) {
    return getComputedStyle(document.documentElement).getPropertyValue(property) || defaultValue;
}
//# sourceMappingURL=lxl-css.js.map